import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { NumberTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { VetDetailsDialogComponent } from './vet-details-dialog/vet-details-dialog.component';
import { VetVetGroupDetailsDialogComponent } from './vet-vet-group-details-dialog/vet-vet-group-details-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { CombinedBenutzerTierarztDialogComponent } from './combined-benutzer-tierarzt-dialog/combined-benutzer-tierarzt-dialog.component';
import { Tierarzt } from '../../../../projects/kiene-core/src/lib/components/tieraerzte/classes/tierarzt';

@Component({ selector: 'kiene-vet', templateUrl: './vet.component.html', styleUrls: ['./vet.component.scss'] })
export class VetComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly messageService: MessageService,
        private readonly api: KieneTableService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Tierärzte';
        this.tableDescriptor.uniqueIdentifier = 'Tierärzte';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'tierarzt/';
        this.tableDescriptor.route = '/administration/tierarzte/';
        this.tableDescriptor.nameOfIdField = 'tierarzt_id';
        this.tableDescriptor.searchPlaceholder = 'Tierärzte durchsuchen';
        this.tableDescriptor.columns.push(new TableColumn('nachname', 'Nachname'));
        this.tableDescriptor.columns.push(new TableColumn('vorname', 'Vorname'));
        this.tableDescriptor.columns.push(new NumberTableColumn('tierarztnummer', 'Tierarztnummer', '3.0-0'));
        this.tableDescriptor.columns.push(new NumberTableColumn('abgabebeleg_nr', 'Nächste Abgabebelegnr.', '6.0-0'));
        this.tableDescriptor.columns.push(new TableColumn('qs_alias', 'QS Alias'));
        this.tableDescriptor.columns.push(new TableColumn('tierarztgruppe', 'Tierarztgruppe'));
        this.tableDescriptor.columns.push(new TableColumn('lagerplatz', 'Lagerplatz'));
        this.tableDescriptor.columns.push(new TableColumn('kostenstelle', 'Kostenstelle'));

        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.permissionCreate = 1252;
        this.tableDescriptor.permissionView = 1251;

        this.tableDescriptor.options.push(
            new TableOption(this.openEditVetDialog.bind(this), 'Einstellungen', 'edit', 1253),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.openEditVetGroupDialog.bind(this), 'Tierarztgruppe ändern', 'forward', 1253),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.openDeleteConfirmDialog.bind(this), 'löschen', 'delete', 1254),
        );

        this.tableDescriptor.initialSortColumn = 'nachname';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.openAddVetDialog.bind(this);
    }

    openAddVetDialog() {
        this.dialog
            .open(CombinedBenutzerTierarztDialogComponent, { width: '700px' })
            .afterClosed()
            .subscribe((newVet: Tierarzt) => {
                if (newVet) {
                    this.api.reload();
                }
            });
    }

    openEditVetDialog(vet: Tierarzt) {
        const dialogRef = this.dialog.open(VetDetailsDialogComponent, { width: '700px', data: { tierarzt: vet } });
        dialogRef.afterClosed().subscribe(vetEdit => {
            if (vetEdit) {
                this.api.updateEntity(this.apiBaseUrl + 'tierarzt_mandant/update.php', vetEdit).subscribe(
                    () => {
                        this.messageService.infoMessage('Der Tierarzt  wurde erfolgreich aktualisiert!');
                        this.api.reload();
                    },
                    error => {
                        this.messageService.errorMessage('Tierarzt konnte nicht editiert werden! Fehler: ', error);
                    },
                );
            }
        });
    }

    openEditVetGroupDialog(vet: Tierarzt) {
        const dialogRef = this.dialog.open(VetVetGroupDetailsDialogComponent, {
            width: '700px',
            data: { tierarzt: vet },
        });
        dialogRef.afterClosed().subscribe(vetEdit => {
            if (vetEdit) {
                this.api.updateEntity(this.apiBaseUrl + 'tierarzt/update.php', vetEdit).subscribe(
                    response => {
                        this.messageService.infoMessage(
                            'Tierarzt ' + response.vorname + ' ' + response.nachname + ' wurde erfolgreich editiert!',
                        );
                        this.api.reload();
                    },
                    error => {
                        this.messageService.errorMessage('Tierarzt konnte nicht editiert werden! Fehler: ', error);
                    },
                );
            }
            this.api.reload();
        });
    }

    openDeleteConfirmDialog(vet: Tierarzt) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '350px',
            data: {
                title: 'Tierarzt löschen',
                text: 'Wollen Sie den Tierarzt ' + vet.vorname + ' ' + vet.nachname + ' wirklich löschen?',
                textButton: 'Löschen',
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.deleteVet(vet);
            }
        });
    }

    deleteVet(vet: Tierarzt) {
        this.api.deleteEntity(this.apiBaseUrl + 'tierarzt/delete.php', vet).subscribe(
            () => {
                this.messageService.infoMessage(
                    'Tierarzt ' + vet.vorname + ' ' + vet.nachname + ' erfolgreich entfernt!',
                );
                this.api.reload();
            },
            error => {
                console.error(error);
                this.messageService.errorMessage(
                    'Löschen von Tierarzt ' + vet.vorname + ' ' + vet.nachname + ' ist fehlgeschlagen!',
                    error,
                );
            },
        );
    }
}
